import { makeActionCreator } from '../../../utilities'
import { PcsInformationConstants } from './pcsInformation.constants'

export const setConsentFormSigned = makeActionCreator(
  PcsInformationConstants.SET_CONSENTFORMSIGNED,
  'consentFormSigned'
)
export const setNppFormGiven = makeActionCreator(PcsInformationConstants.SET_NPPFORMGIVEN, 'nppFormGiven')
export const setMedicalNecessitySigned = makeActionCreator(
  PcsInformationConstants.SET_MEDICALNECESSITYSIGNED,
  'medicalNecessitySigned'
)
export const setPcsReason = makeActionCreator(PcsInformationConstants.SET_PCSREASON, 'pcsReason')
export const setPcsProviderType = makeActionCreator(PcsInformationConstants.SET_PCSPROVIDERTYPE, 'pcsProviderType')
export const setLastName = makeActionCreator(PcsInformationConstants.SET_LASTNAME, 'lastName')
export const setFirstName = makeActionCreator(PcsInformationConstants.SET_FIRSTNAME, 'firstName')
export const setMilesToHosp = makeActionCreator(PcsInformationConstants.SET_MILESTOHOSP, 'milesToHosp')
export const setPcsSignedTime = makeActionCreator(PcsInformationConstants.SET_PCSSIGNEDTIME, 'pcsSignedTime')
export const setPcsSignedDate = makeActionCreator(PcsInformationConstants.SET_PCSSIGNEDDATE, 'pcsSignedDate')
export const savePcsInformation = makeActionCreator(PcsInformationConstants.SAVE_PCSINFORMATION)
export const setSavePcsInformationResponse = makeActionCreator(PcsInformationConstants.SET_RESPONSE, 'response')
export const resetPCSInformationState = makeActionCreator(PcsInformationConstants.RESET_PCSINFORMATION_STATE)
export const setPcsInformation = makeActionCreator(PcsInformationConstants.SET_PCSINFORMATION, 'pcsInformation')
